module.exports = {
    CUSTOM: 'custom',
    NATIVE: 'native'
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/language-selector/types.js
 ** module id = 70
 ** module chunks = 14
 **/